import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class AnswerDragButton extends Phaser.GameObjects.Container {
  constructor(scene, btnType, cont) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;
    this.btnType = btnType;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'CircleShadow', this).setOrigin(0, 0);

    this.buttonDisplay = ABCyaPhaser.Images.addImage(6, 6, `Circle${this.btnType}`, this).setOrigin(0, 0);

    this.setSize(this.buttonDisplay.getBounds().width, this.buttonDisplay.getBounds().height);
    this.setInteractive({ useHandCursor: true, draggable: true });
    this.input.hitArea.setTo(this.buttonDisplay.getBounds().width / 2, this.buttonDisplay.getBounds().height / 2, this.buttonDisplay.getBounds().width, this.buttonDisplay.getBounds().height);
  }
}